import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/subtypes/Page";

export const PATH = "/settings/subtypes";

const Home: NextPage = () => (
	<>
		<NskHead title="案件タイプ設定" />
		<Component />
	</>
);

export default Home;
